module.exports = __webpack_public_path__ + "img/app13.70f7cbef.png";